import { Box, Button, Typography } from "@mui/material";
import React from "react";
import bgImage1 from "../assets/img/bg-image1.png"

const CallToActionSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "628px",
        bgcolor: "#09090f",
        position: "relative",
        padding: "92px 0",
      }}
    >
      <Box
        sx={{
          height: "444px",
        //   maxWidth: "920px",
          margin: "0 auto",
          borderRadius: "23px",
          backgroundImage: `url(${bgImage1})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 50%",
          position: "relative",
        }}
      >
        <Box sx={{
            position: "absolute",
            top:0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
            backgroundColor: {
                xs: "rgba(0,0,0,.45)",
                sm: "unset"
            }
        }}>

        </Box>
        <Box
          sx={{
            width: "416px",
            position: "absolute",
            top: "94px",
            right: "0",
            padding: "0 20px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Spline_Sans_Mono-SemiBoldItalic', Helvetica",
              fontWeight: 600,
              fontStyle: "italic",
              color: {
                xs: "white",
                sm: "#16130f"
              },
              fontSize: "28px",
              lineHeight: "46.8px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              boxSizing: "border-box"
            }}
          >
            Effortless File Management
          </Typography>

          <Typography
            sx={{
              fontFamily: "'Space_Grotesk-Regular', Helvetica",
              fontWeight: 400,
              color: {
                xs: "white",
                sm: "#67460d"
              },
              fontSize: "17px",
              lineHeight: "26.7px",
              mt: "62px",
              mb: "82px",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
            }}
          >
            Streamline your data management with our intuitive platform,
            providing you with the tools and features to organize, access, and
            share your files with ease
          </Typography>

          <Button
            variant="contained"
            sx={{
              width: "143px",
              height: "55px",
              bgcolor: "#fefefe",
              borderRadius: "55px",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#f0f0f0",
                boxShadow: "none",
              },
            }}
            onClick={() => {
                const section = document.getElementById("order-now-section");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
          >
            <Typography
              sx={{
                fontFamily: "'Inter-Regular', Helvetica",
                fontWeight: 400,
                color: "#716b6c",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              Try it Now
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CallToActionSection;